import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=28008e4c&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=28008e4c&prod&scoped=true&lang=css"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=28008e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28008e4c",
  null
  
)

export default component.exports